/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Streak_PillInputs */

const en_us2_share_streak_pill = /** @type {(inputs: Share_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streak`)
};

const pt_br2_share_streak_pill = /** @type {(inputs: Share_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequência`)
};

const es_419_share_streak_pill = /** @type {(inputs: Share_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Racha`)
};

const pt_pt2_share_streak_pill = /** @type {(inputs: Share_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequência`)
};

const fr_fr2_share_streak_pill = /** @type {(inputs: Share_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série`)
};

const de_de2_share_streak_pill = /** @type {(inputs: Share_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie`)
};

const it_it2_share_streak_pill = /** @type {(inputs: Share_Streak_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costanza`)
};

/**
* | output |
* | --- |
* | "Streak" |
*
* @param {Share_Streak_PillInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_streak_pill = /** @type {((inputs?: Share_Streak_PillInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Streak_PillInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_streak_pill(inputs)
	if (locale === "es-419") return es_419_share_streak_pill(inputs)
	if (locale === "pt-PT") return pt_pt2_share_streak_pill(inputs)
	if (locale === "fr-FR") return fr_fr2_share_streak_pill(inputs)
	if (locale === "de-DE") return de_de2_share_streak_pill(inputs)
	if (locale === "it-IT") return it_it2_share_streak_pill(inputs)
	return en_us2_share_streak_pill(inputs)
});
export { share_streak_pill as "share.streak_pill" }